import React from 'react';

import Heading from '../../../../generic-components/Heading';

interface LoginLineDotProps {
  number: string;
  title: string;
  testId?: string;
}

const LoginLineDot = ({ number, title, testId }: LoginLineDotProps) => (
  <div className='inline-flex mb-2 font-metric text-bw07' data-testid={testId}>
    <div className='w-[22px] h-[22px] bg-action02 rounded-full flex text-center align-middle justify-center'>
      <div className='text-[white] font-bw00 '>{number}</div>
    </div>
    <Heading className='ml-[0.5em]' title={title} />
  </div>
);

export default LoginLineDot;
